import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { Button } from '@abroad/components'
import { AvailabilityTab, LimitsTab } from './index'

export const TAB_TYPES = {
  AVAILABILITY: 'availability',
  LIMITS: 'limits',
}

const SettingTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className='mb-4'>
      <Button
        variant='none'
        className='navTabs ml-0'
        style={{
          background: activeTab === TAB_TYPES.AVAILABILITY ? '#0A223C' : '',
          color: activeTab === TAB_TYPES.AVAILABILITY ? '#fff' : '',
        }}
        onClick={() => onTabChange(TAB_TYPES.AVAILABILITY)}>
        AVAILABILITY
      </Button>
      <Button
        variant='none'
        className='navTabs'
        style={{
          background: activeTab === TAB_TYPES.LIMITS ? '#0A223C' : '',
          color: activeTab === TAB_TYPES.LIMITS ? '#fff' : '',
        }}
        onClick={() => onTabChange(TAB_TYPES.LIMITS)}>
        LIMITS
      </Button>
    </div>
  )
}

const resolveSettingTab = (tab) =>
  tab && Object.values(TAB_TYPES).includes(tab) ? tab : TAB_TYPES.AVAILABILITY

const SettingTab = ({ timezone }) => {
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(() =>
    resolveSettingTab(location.state?.settingTab),
  )

  useEffect(() => {
    if (location.state?.settingTab) {
      setActiveTab(resolveSettingTab(location.state.settingTab))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state?.settingTab])

  const handleTabChange = (tab) => {
    setActiveTab(tab)
  }

  return (
    <div>
      <SettingTabs activeTab={activeTab} onTabChange={handleTabChange} />
      {activeTab === TAB_TYPES.AVAILABILITY && (
        <AvailabilityTab timezone={timezone} />
      )}
      {activeTab === TAB_TYPES.LIMITS && <LimitsTab />}
    </div>
  )
}

SettingTab.propTypes = {
  timezone: PropTypes.string,
}

export default SettingTab
